export default {
  identification: '身份证',
  country: '国家',
  department: '部门',
  description: '部门',
  charge: '职务',
  screen: '屏幕'
}
